import React from 'react';

type LabelProps = {
  label?: string;
  LabelIcon?: React.ElementType;
};

const Label = ({ label, LabelIcon }: LabelProps) => (
  <div className="tw-items-center tw-flex tw-gap-1">
    {LabelIcon && <LabelIcon size={20} color="var(--color-text-primary)" />}
    <span className="tw-text-xs/3 tw-font-medium">{label}</span>
  </div>
);

export default Label;
